/**
 * Checks whether an user's zip code is semantically valid
 * @param zip - The string to be tested
 * @returns True if valid, False if invalid
 */
export default function validateZipCode(zip: string) {
  return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip);
}
